import { render } from "./peñafiel_adasView.vue?vue&type=template&id=ffc23082"
import script from "./peñafiel_adasView.vue?vue&type=script&lang=js"
export * from "./peñafiel_adasView.vue?vue&type=script&lang=js"

import "./peñafiel_adasView.vue?vue&type=style&index=0&id=ffc23082&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__